import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import { Table } from "../../../components/Table/Table";
import { dummyimage, edit_icon, vedio } from "../../../assets/img";
// import vedioFile from "../../../assets/img/"
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../redux/api/PermissionManager";

const Vedio = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [video, setVideo] = useState(null);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const inputRef = useRef(null);
  const [totalCount, setTotalCount] = useState();
  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);

  // ✅ Toggle status
  const handleStatus = async ({ id, status }) => {
    const formdata = new FormData();
    formdata.append("status", !status);

    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetch();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const fetch = async () => {
    try {
      const url = search
        ? `${URLS.MASTERURL}?type=${17}&search=${search}`
        : `${URLS.MASTERURL}?type=${17}`;
      const res = await get(url);

      setList(res?.results || res?.data || []);
      setTotalCount(res?.count);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch();
  }, [search, editId]);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("video/")) {
      setVideo(file);
    } else {
      alert("Please select a valid video file");
    }
  };

  const handleUpload = async () => {
    const formdata = new FormData();
    formdata.append("type", 17);

    if (video && typeof video !== "string") {
      formdata.append("icon", video);
      console.log("formDataSSimage", video);
    }

    const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);

    window.location.reload();

    setAddPopup(false);
    setVideo("");
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Video",
        accessor: "icon",
        Cell: ({ value }) => {
          return value ? (
            <video
              width="170"
              height="100"
              controls
              className="list-video"
              style={{ objectFit: "cover", borderRadius: "6px" }}
            >
              <source src={value} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={vedio}
              alt="placeholder"
              className="list-img"
              style={{ width: "80px", height: "40px", objectFit: "cover" }}
            />
          );
        },
      },

      //   {
      //     Header: " Start Date",
      //     accessor: "startDate",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      //   {
      //     Header: " Start Time",
      //     accessor: "startTime",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      //   {
      //     Header: " End Date",
      //     accessor: "endDate",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      //   {
      //     Header: " End Time",
      //     accessor: "endTime",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-VIDEO"))
                    handleStatus(row.original);
                }}
                className={`${
                  value == false ? "deactive-btn" : "active-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value == false ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js">
                {checkPermission("CAN-EDIT-VIDEO") && (
                  <button
                    onClick={() => {
                      setAddPopup(true);
                      setType("edit");
                      setEditId(row.original.id);
                      setVideo(row.original?.icon);
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Vedio"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:1
        </h2>
      </div>
      <h4 className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err mt-4">
        Max Upload Size : 5MB and Vedio Size 1200px 700px*
      </h4>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={false}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                Edit
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setVideo("");
                }}
                className="pointer"
              />
            </div>
            <div
              style={{ flexDirection: "row" }}
              className="d-flex ac-jb px-2 mt-5"
            >
              <div className="w-40 ">
                <input
                  style={{ width: "100px", height: "70px" }}
                  type="file"
                  accept="video/*"
                  onChange={handleVideoChange}
                  ref={inputRef}
                  hidden
                />
                {!video && (
                  <img
                    src={vedio}
                    alt=""
                    onClick={handleClick}
                    style={{
                      width: "80px",
                      height: "70px",
                      textAlign: "start",
                    }}
                  />
                )}
                {video && (
                  <button
                    style={{ border: "none", padding: 10 }}
                    onClick={handleClick}
                    className="position-relative"
                  >
                    {/* <HighlightOffRoundedIcon
                      className="pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      style={{
                        position: "absolute",
                        right: "-8px",
                        top: "-10px",
                      }}
                    /> */}
                    <span style={{ fontWeight: 600, color: "#9a36e6" }}>
                      Upload
                    </span>
                    <video
                      style={{ marginTop: 4 }}
                      width="150"
                      height="80"
                      controls
                      src={
                        video instanceof File
                          ? URL.createObjectURL(video)
                          : video
                      }
                      onClick={(e) => {
                        e.stopPropagation(); // ⛔ prevent bubbling if needed
                        handleClick(video); // 👈 navigate/preview
                      }}
                    />
                    {/* <p>{video.name}</p> */}
                  </button>
                )}
              </div>

              <button
                onClick={() => {
                  handleUpload();
                  setAddPopup(false);
                  // logout();
                }}
                style={{ marginLeft: 40 }}
                className="submit-btn f2 w-60"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vedio;
